import React from 'react';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import Preloader from '@components/preloader';
import Button from '@components/button';
import { getAdMarkText } from '../../utils/index';
import { getPageNameByLocation } from '../../utils/getPageNameByLocation';
import { MINDIGITAL_CERTIFICATES_URL } from '../../constants/links';

import * as styles from './App.scss';
import strings from '../../strings';

const App = (props) => {
  const {
    showLoadingPage,
    systemName,
    title,
    description,
    iframeUrl,
    iframeHeight,
    advertiserFirmInn,
    advertiserFirmName,
    erir,
    handleButtonClick,
    showAdvertisementBlock,
    partnerSiteIsUnavailable,
  } = props;

  const advText = getAdMarkText(
    strings.advertizerNameText,
    advertiserFirmName,
    strings.advertizerInnText,
    advertiserFirmInn,
    strings.advertizerErirText,
    erir,
  );

  const pageName = getPageNameByLocation(window.location);

  if (showLoadingPage) {
    return (
      <div className={styles.loading}>
        <Preloader
          width={70}
        />
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.container, {
        [styles.containerCentered]: partnerSiteIsUnavailable,
      })}
    >
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {pageName && <link rel="canonical" href={`https://ati.su/partner-page/${pageName}`} />}
      </Helmet>
      <Button
        onClick={handleButtonClick}
        className={styles.button}
      >
        {strings.toPartnersLanding}
      </Button>
      {partnerSiteIsUnavailable ? (
        <div className={styles.unavailable}>
          <div>{strings.partnerSiteUnavailable}</div>
          <div>
            {strings.certificatesInstruction}
            {' '}
            <a
              className="glz-link glz-is-large glz-is-primary"
              href={MINDIGITAL_CERTIFICATES_URL}
              target="_blank"
              rel="noreferrer"
            >
              {strings.certificatesInstructionLink}
            </a>
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          <iframe
            src={iframeUrl}
            height={iframeHeight}
            title={systemName}
            className={styles.iframe}
          />
          {showAdvertisementBlock && (
            <div className={styles.marker}>
              {advText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default App;
